import { type TabProps, useBlotterTableStorage, useCallbackRef, type UseTabsProps } from '@talos/kyoko';

/** Connects the Tab's onClone callback with the act of actually cloning the necessary BlotterTableState from the original to the newly cloned blotter */
export const useBlotterTableTabCloning = ({ getBlotterID }: { getBlotterID: (tabID: string) => string }) => {
  const { cloneState } = useBlotterTableStorage();

  const onClone: UseTabsProps['onClone'] = useCallbackRef((original: TabProps, clone: TabProps) => {
    if (!original.id || !clone.id) {
      return;
    }

    cloneState(getBlotterID(original.id), getBlotterID(clone.id));
  });

  return onClone;
};
